import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  onClick?(): void;
  disabled?: boolean;
};

export function BackButton({ onClick, disabled }: Props) {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Button
      variant="outlined"
      fullWidth={true}
      disabled={disabled}
      startIcon={<ArrowBackIcon />}
      onClick={onClick ?? handleBack}
    >
      Back
    </Button>
  );
}
